export default __webpack_public_path__ + "static/media/UniversLTStd.f6f9029c.otf";